import { createGlobalStyle } from 'styled-components';
import { ColorNordicGrey4 } from 'autogen/design-tokens/tokens';

const bodyBackgroundColor = ColorNordicGrey4;

const ArticleUniverseGlobalStyling = createGlobalStyle`
    body {
        background-color: ${bodyBackgroundColor};
    }
`;

export default ArticleUniverseGlobalStyling;
export { bodyBackgroundColor };
